import { LoginTranslation } from 'locales/de/pages/login';

const en: LoginTranslation = {
  title: 'Login',
  titleEmail: 'Login with email',
  titleUserExists: 'Login with selected User',
  titleUserCreate: 'Create User',
  rememberMe: 'Remember me',
  signIn: 'TH Login',
  signInExternal: 'External Login',
  forgot: 'Forgot password?',
  alerts: {
    loginFailed: 'Login failed. Please check your credentials.',
    registerSuccessful:
      'Registration successful. You will receive an email describing the next steps shortly.',
    registerFailed: 'Registration failed.',
    confirmFailed:
      'The token is invalid. Please issue a new one via the "Forgot Password" function.',
    setPasswordSuccessful:
      'Successfully saved the password. You can now log in with your credentials.',
    setPasswordFailed: 'The password could not be saved.',
    forgotPasswordSuccessful:
      'If this e-mail address is registered with us, you will receive an e-mail with further insturctions shortly.',
    errorLoading: 'Faculties could not be loaded.'
  },
  registerTitle: 'Register',
  registerButton: 'Register for free',
  formDescriptions: {
    contactData:
      'Please provide your personal contact information. These will be displayed in your job offers later.',
    companyData:
      "Now please provide your company's information. These will be displayed as general contact information in your job offers and are needed for the billing address.",
    companyDescription:
      "Describe your company here. This can be seen on your company's profile page.",
    facultyData:
      'Choose the courses of study you have job offers for. These can be changed any time.',
    invoiceData:
      'Please enter invoice information. If your company address is the same as the invoice address, check the corresponding box in the company data.',
    invoiceInfo:
      'Your billing information will only be used when a paid Job Offer is placed. Those are marked as such.',
    taxIdInfo: 'Tax-ID without spaces and special characters',
    requiredEitherUstIdOrTaxId: 'In Germany you have to provide either the USt-ID or TaxID'
  },
  formSteps: {
    contact: 'Contact',
    company: 'Company',
    companyDescription: 'Company Description',
    faculties: 'Faculties',
    invoice: 'Invoice'
  },
  confirmTitle: 'Set password',
  confirmDescription:
    'The token check was successful. Please provide your new password down below. You can use that to log in to your account from now on.',
  passwordHelperText:
    'The password needs to be at least 8 characters long and include at least one upper case letter, one digit and one special character.',
  forgotTitle: 'Forgot password',
  forgotDescription:
    "Please enter your e-mail address. If it's registered with us, we will send you an e-mail with an activation link.",
  processLogin: 'Please be patient while your login request is being processed...',
  loginSelection: {
    companyLogin: {
      title: 'Companies & Partner',
      description: 'Register you company and use the jobmarket of the TH-Rosenheim'
    },
    universityLogin: {
      title: 'University Login',
      description: 'For university members (students, faculty, staff)'
    },
    internationalOfficeLogin: {
      title: 'International Office',
      description: 'For incoming students'
    },
    developerLogin: {
      title: 'Developer Login',
      description: 'Build own user'
    }
  },
  or: 'Or'
};

export default en;
